export function chunkArray(arr, chunkSize) {
    return arr.reduce((prevVal, currVal, currIndx, array) => !(currIndx % chunkSize) ? prevVal.concat([array.slice(currIndx, currIndx + chunkSize)]) : prevVal, []);
}
export function mergeArrayAtIndex(baseArray, mergeArray, index, limit) {
    if (index === 0) {
        return new Array().concat(mergeArray.slice(0, limit)).concat(baseArray);
    }
    return chunkArray(baseArray, index)
        .map((chunk, chunkIndex) => new Array()
        .concat(chunk)
        .concat(chunk.length < index || (limit !== undefined && chunkIndex >= limit)
        ? []
        : mergeArray[chunkIndex % mergeArray.length]))
        .flat();
}
//# sourceMappingURL=ArrayUtils.js.map